module.exports = __webpack_public_path__ + "img/tools.e8491682.svg";